export default __webpack_public_path__ + "static/media/Lip_9_F.e5ae4e88.svg";